import { unByKey } from "ol/Observable";
import { getRenderPixel } from "ol/render";

export const swipeMap = ({ map, layers, borderLayer, sidoBorderLayer }) => {
    const swipe = document.getElementById('swipe');

    const preRenderHandle0 = (event) => {
        const ctx = event.context;
        const mapSize = map.getSize();
        const width = mapSize[0] * (swipe.value / 100);
        const tl = getRenderPixel(event, [0, 0]);
        const tr = getRenderPixel(event, [width, 0]);
        const bl = getRenderPixel(event, [0, mapSize[1]]);
        const br = getRenderPixel(event, [width, mapSize[1]]);
        
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(tl[0], tl[1]);
        ctx.lineTo(bl[0], bl[1]);
        ctx.lineTo(br[0], br[1]);
        ctx.lineTo(tr[0], tr[1]);
        ctx.closePath();
        ctx.clip();
    }

    const postRenderHandle0 = (event) => {
        const ctx = event.context;
        ctx.restore();
    }

    const preRenderHandle1 = (event) => {
        const ctx = event.context;
        const mapSize = map.getSize();
        const width = mapSize[0] * (swipe.value / 100);
        const tl = getRenderPixel(event, [width, 0]);
        const tr = getRenderPixel(event, [mapSize[0], 0]);
        const bl = getRenderPixel(event, [width, mapSize[1]]);
        const br = getRenderPixel(event, mapSize);
      
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(tl[0], tl[1]);
        ctx.lineTo(bl[0], bl[1]);
        ctx.lineTo(br[0], br[1]);
        ctx.lineTo(tr[0], tr[1]);
        ctx.closePath();
        ctx.clip();
    }

    const postRenderHandle1 = (event) => {
        const ctx = event.context;
        ctx.restore();
    }

    const mountEvent = () => {
        layers[0].setVisible(true);
        layers[1].setVisible(true);
        
        const key0 = layers[0].on('prerender', preRenderHandle0);
        const key1 = layers[0].on('postrender', postRenderHandle0);
        const key2 = layers[1].on('prerender', preRenderHandle1);
        const key3 = layers[1].on('postrender', postRenderHandle1);

        swipe.addEventListener('input', () => {
            map.render();
        });

        map.render();

        return [key0, key1, key2, key3];
    }

    const dismountEvent = (swipeEventKeyArray) => {
        swipeEventKeyArray.forEach((key) => 
            unByKey(key)
        )

        map.render();
    }

    return { mount: mountEvent, dismount: dismountEvent };
}